import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import { logout, getOxygenUrl, getAccHostname } from '@adsk/acs-sc-web-platform-api';
import * as analytics from '@adsk/acs-web-analytics';
import { clearNetworkCache } from '@adsk/alloy-helpers';
import A from '@adsk/alloy-react-a';
import Button from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-locale';
import theme from '@adsk/alloy-react-theme';
import { ANALYTICS_TYPES } from '../helpers/analytics';
import getNotificationSettingsUrl from '../helpers/getNotificationSettingsUrl';
import { userShape } from '../helpers/propTypes';
/**
 * Acs TopNavigation
 */
const Profile = _ref => {
  let {
    showSubscriptionsModal,
    user,
    projectId,
    onLogout,
    onClose,
    onOpenSubscriptions
  } = _ref;
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require("../i18n/".concat(locale, ".json"));
  });
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: [{
      minWidth: '250px',
      padding: '24px'
    }]
  }, /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: [theme.typography.heading4, {
      color: theme.colors.charcoal900
    }]
  }, user.firstName, " ", user.lastName), /*#__PURE__*/React.createElement(_StyledDiv3, {
    $_css3: [theme.typography.bodySmall, {
      color: theme.colors.charcoal600
    }]
  }, user.email), showSubscriptionsModal && /*#__PURE__*/React.createElement(_StyledDiv4, {
    $_css4: [theme.typography.bodySmall, {
      color: theme.colors.charcoal600,
      marginTop: 10
    }]
  }, /*#__PURE__*/React.createElement("a", {
    style: {
      cursor: 'pointer'
    },
    onClick: () => {
      onClose();
      analytics.track(ANALYTICS_TYPES.TOPNAVIGATION_USERAREA_MYSUBSCRIPTIONS_CLICK);
      onOpenSubscriptions();
    },
    "data-testid": "My__Subscriptions__Label",
    rel: "noopener noreferrer"
  }, T.translate('MY_SUBSCRIPTIONS'))), projectId && /*#__PURE__*/React.createElement(_StyledDiv5, {
    $_css5: [theme.typography.bodySmall, {
      color: theme.colors.charcoal600,
      marginTop: 10
    }]
  }, /*#__PURE__*/React.createElement(A, {
    href: getNotificationSettingsUrl(projectId),
    rel: "noopener noreferrer",
    onClick: () => analytics.track(ANALYTICS_TYPES.TOPNAVIGATION_USERAREA_NOTIFICATIONSETTINGS_CLICK)
  }, T.translate('NOTIFICATION_SETTINGS'))), /*#__PURE__*/React.createElement(_StyledDiv6, {
    $_css6: [{
      paddingTop: '32px'
    }]
  }, /*#__PURE__*/React.createElement(Button, {
    as: "a",
    href: getOxygenUrl(),
    rel: "noopener noreferrer",
    target: "_blank",
    variant: Button.VARIANTS.PRIMARY,
    size: Button.SIZES.SMALL,
    style: {
      marginRight: 12
    },
    onClick: () => {
      analytics.track(ANALYTICS_TYPES.TOPNAVIGATION_USERAREA_PROFILESETTINGS_CLICK);
      onClose();
    }
  }, T.translate('PROFILE_SETTINGS')), /*#__PURE__*/React.createElement(Button, {
    variant: Button.VARIANTS.SECONDARY,
    size: Button.SIZES.SMALL,
    onClick: () => {
      clearNetworkCache();
      analytics.track(ANALYTICS_TYPES.TOPNAVIGATION_USERAREA_SIGNOUT_CLICK);
      if (onLogout) {
        onLogout();
      }
      logout(getAccHostname());
      onClose();
    }
  }, T.translate('SIGN_OUT'))));
};
Profile.displayName = 'Profile';
Profile.propTypes = {
  /** show subscriptions modal (page level) */
  showSubscriptionsModal: PropTypes.bool,
  /** current user */
  user: userShape,
  /** current selected project id */
  projectId: PropTypes.string,
  /** callback called on logout */
  onLogout: PropTypes.func,
  /** menu close handler */
  onClose: PropTypes.func.isRequired,
  /** opens my subscriptions modal */
  onOpenSubscriptions: PropTypes.func.isRequired
};
export default Profile;
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), p => p.$_css);
var _StyledDiv2 = _styled2("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), p => p.$_css2);
var _StyledDiv3 = _styled3("div")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), p => p.$_css3);
var _StyledDiv4 = _styled4("div")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), p => p.$_css4);
var _StyledDiv5 = _styled5("div")(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", ""])), p => p.$_css5);
var _StyledDiv6 = _styled6("div").withConfig({
  displayName: "Profile___StyledDiv6",
  componentId: "sc-25kvzh-0"
})(["", ""], p => p.$_css6);
//# sourceMappingURL=Profile.js.map